<template>
  <main style="margin-bottom: 60px;">
    <div class="doctor d-flex align-items-center p-3 mb-2">
      <div class="pr-3">
        <img
          :src="avatar"
          alt=""
          width="64"
          height="64"
          class="img-fluid rounded-circle">
      </div>
      <div>
        <div class="name pb-1">{{ doctorName }}</div>
        <div class="title">{{ doctorTitle }}</div>
      </div>
    </div>
    <p class="ml-2">温馨提示</p>
    <div class="hint px-2">
      <p class="pt-2">支付成功后，我们会在24小时内安排医生为您看片写片；</p>
      <p>名医是医院在职医生，利用休息时间为您服务，如未能及时响应您的看片需求，我们会在24小时内联系您，为您退单或者更换其他医生，敬请谅解！</p>
      <p class="pb-2">您有任何问题，可以通过依康宝APP公众号联系我们（9:00-18:00）</p>
    </div>
    <PaymentList
      :list="billItems"
      class="mt-2"/>
    <van-checkbox
      v-model="agreement"
      class="m-2">
      <span>同意</span><a href="https://resource.yikangbao.com.cn/cloud-film/mingyi-agreement.html">《专家看片服务协议》</a>
    </van-checkbox>
    <div class="fixed-bottom d-flex">
      <span class="flex-grow-1 price">
        问诊费用: {{ price.toFixed(2) }} 元
      </span>
      <van-button
        :disabled="!agreement"
        type="danger"
        class="rounded-0"
        @click="handleCreatePayBill">问诊</van-button>
    </div>
  </main>
</template>

<script>
import { apiURL } from '@/libs/const';
import PaymentList from './components/PaymentList.vue';

export default {
  components: {
    PaymentList,
  },
  data() {
    return {
      price: sessionStorage.getItem('doctor_current_price'),
      doctorName: '',
      doctorTitle: '',
      billItems: [],
      agreement: false,
    };
  },
  computed: {
    avatar() {
      const { id } = this.$route.params;
      return `${apiURL}/cloud-film-api/webapi/professional/get-doctor-avatar/${id}`;
    },
  },
  activated() {
    // this.handleLoad();
    this.doctorName = sessionStorage.getItem('doctor_name');
    this.doctorTitle = sessionStorage.getItem('doctor_title');
  },
  methods: {
    async handleCreatePayBill() {
      this.loading = true;
      const response = await this.$http
        .post('/cloud-film-api/webapi/order/create-pay-bill', {
          order_code: this.$route.query.billCode,
        })
        .catch(() => {
          this.loading = false;
        });
      sessionStorage.setItem('my_bill_code', this.$route.query.billCode);
      window.location.href = `/cloud-film/payment?billCode=${response.bill_code}&type=doctor`;
    },
  },
};
</script>

<style scoped>
  .doctor {
    background-color: #ffffff;
  }

  .name {
    font-size: 24px;
  }
  .title {
    color: #888888;
  }

  .hint {
    background-color: #ffffff;
  }

  .agreement>a {
    color: #1C88FF;
  }

.price {
  background-color: #fff;
  line-height: 44px;
  padding-right: 12px;
  color: #f44;
  text-align: right;
}
</style>
